import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

class RewardsStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      rewards: [],
      loading: false,
      error: null,
      userPoints: 0,
      userLevel: 1,
      levelName: 'Débutant',
      stats: { total: 0, locked: 0, active: 0, claimed: 0 },
      milestones: [],
      badges: [],
      gamificationProfile: null,
      userLevelData: {
        level: 1,
        activeMilestone: 'firstOrder',
        xpPercent: 0,
        currentXp: 0,
        totalXp: 0,
        requiredLevelXp: 0,
        isElligible: false
      },
      previousUserLevelData: null,
      lastLevelAnimation: null
    };
    super('rewards', initialState, { useLocalStorage: false });
  }

  get completedRewards() {
    return this.state.rewards.filter(r => r.status === 'done');
  }

  get activeRewards() {
    return this.state.rewards.filter(r => r.status === 'active');
  }

  get lockedRewards() {
    return this.state.rewards.filter(r => r.status === 'locked');
  }
}

export default RewardsStore;
